/*订单管理*/
<template>
  <div id="orderTabs">
    <el-tabs type="card" v-model="tabAction" @tab-click="handleTabClick">
      <el-tab-pane v-for="item in tabs" :key="item.name" :name="item.name">
        <template slot="label">
          <i v-if="item.icon" :class="item.icon" style="margin-right: 4px"></i>{{ item.label }}
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="content" v-show="tabs.length > 0">
      <keep-alive>
        <component :is="currentComponent" :key="tabAction"></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// 专线订单
import OrderCustomize from './customize/orderCustomize.vue'
// 班线订单
import OrderLine from './line/orderLine.vue'
// 旅游包车
import OrderChartered from './chartered/orderChartered.vue'
// 专线包车
import OrderCustomizeChartered from './customizeChartered/orderCustomizeChartered.vue'
// 顺风车
import OrderHitchhiking from './orderHitchhiking/orderHitchhiking.vue'
// 场站订单
import AirportOrder from '@/page/business_changzhan/operate/order/czOrder.vue'

export default {
  name: "orderTabs",
  components: {
    OrderCustomize,
    OrderLine,
    OrderChartered,
    OrderCustomizeChartered,
    OrderHitchhiking,
    AirportOrder
  },
  data() {
    return {
      // tabs列表
      tabs: [],
      tabAction: null,
    };
  },
  computed: {
    ...mapGetters({ 'permissionsGetter': 'permissionsGetter' }),
    currentComponent() {
      const componentMap = {
        'orderCustomize': 'OrderCustomize',
        'orderLine': 'OrderLine',
        'orderChartered': 'OrderChartered',
        'orderCustomizeChartered': 'OrderCustomizeChartered',
        'orderHitchhiking': 'OrderHitchhiking',
        'airportOrder': 'AirportOrder'
      };
      return componentMap[this.tabAction] || null;
    }
  },
  watch: {
    permissionsGetter: {
      handler() {
        this.getTabs();
      },
      immediate: true
    }
  },
  created() {
    // 从路由参数获取默认 tab
    const tabFromQuery = this.$route.query.tab;
    if (tabFromQuery) {
      this.tabAction = tabFromQuery;
    }
    this.getTabs()
  },
  methods: {
    getTabs() {
      if(this.permissionsGetter.length) {
        let tabs = [];
        if (this.menuPreFn(8)) tabs.push({ label: "专线订单", name: "orderCustomize", icon: 'el-icon-document' });
        if (this.menuPreFn(67)) tabs.push({ label: "班线订单", name: "orderLine", icon: 'el-icon-tickets' });
        if (this.menuPreFn(44)) tabs.push({ label: "旅游包车", name: "orderChartered", icon: 'el-icon-truck' });
        if (this.menuPreFn(45)) tabs.push({ label: "专线包车", name: "orderCustomizeChartered", icon: 'el-icon-truck' });
        if (this.menuPreFn(88)) tabs.push({ label: "顺风车", name: "orderHitchhiking", icon: 'el-icon-position' });
        if (this.menuPreFn(111)) tabs.push({ label: "场站订单", name: "airportOrder", icon: 'el-icon-office-building' });
        this.tabs = tabs;
        if (!this.tabAction && tabs.length > 0) {
          this.tabAction = tabs[0].name;
        }
      } else {
        setTimeout(() => {
          this.getTabs();
        }, 500)
      }
    },
    handleTabClick(tab) {
      this.tabAction = tab.name;
    }
  },
};
</script>

<style lang="less">
#orderTabs {
  height: 100%;

  .content {
    height: calc(100% - 40px);

    &>div {
      height: 100%;
    }
  }
}
</style>
